import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

import './Switcher.scss';

function Switcher({ onClickHandler, isChecked, isDisabled }) {
  return (
    <button
      aria-label="switch button"
      id="mn_switcher"
      className={`mn_switcher ${isChecked ? 'mn_checked' : ''}`}
      onClick={onClickHandler}
      disabled={isDisabled}
    />
  );
}

export default (props) => <ComponentErrorBoundary><Switcher {...props} /></ComponentErrorBoundary>;
